import { h, Component } from 'preact';
import { Link } from "components/core/link/link.js";
import { sortObjectByOrder, joinClasses, accessNested } from 'utils/utils';
import HTML from 'components/core/html/html.js';
import { track } from 'utils/tracking';
import * as actions from 'store/actions';
import Store from 'store/store';
import s from 'components/templates/support/support.sss';

export default class Support extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showAll: false
		};
		this.limit = this.props.isDesktop ? 7 : 3;

		if (this.props.data.showAllLinks) {
			this.limit = Infinity;
		}

		this.renderResource = this.renderResource.bind(this);
		this.toggleShowAll  = this.toggleShowAll.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isDesktop !== this.props.isDesktop && !this.props.data.showAllLinks) {
			this.limit = this.props.isDesktop ? 7 : 3;
		}
	}

	toggleShowAll() {
		const { showAll } = this.state;
		this.setState({ showAll: !showAll });
	}

	trackClick(title, destination) {
		Store.emit(actions.NETFLIX_BUTTON_CLICK, 'finding-support', title, destination)
	}

	renderResource(link, index) {

		const { showAll } = this.state;

		if (index < this.limit || showAll) {
			return (
				<li class={s.resource}>
					{link.title && <HTML tag='h4' markdown class={s.title}>{link.title}</HTML>}
					{link.link && <Link
						href={link.link}
						download={link.download}
						class={s.btn}
						target='_blank'
						trackId={link.trackId}
						extraOnClick={this.trackClick.bind(true, link.title, link.link)}
					>
						<HTML tag="span" content={link.label || this.props.copy.$VISIT_WEBSITE} markdown />
					</Link>}
					{link.text && <HTML tag='p' markdown class={s.text}>{link.text}</HTML>}
				</li>
			);
		}
	}

	render({ data, isDesktop, copy }, { showAll }) {
		const {
			title,
			subtitle,
			links,
			extraClass = ''
		} = data;

		const resources = sortObjectByOrder(links);
		return (
			<div class={joinClasses(s.wrapper, s[extraClass])} id='support' data-section-observed>
				<HTML tag='h2' markdown class={s.title}>{title}</HTML>
				<HTML tag='h4' markdown class={s.subtitle}>{subtitle}</HTML>
				<ul class={joinClasses(s.resources, resources.length < this.limit && s.center)}>
					{resources.map(this.renderResource)}
				</ul>
				{resources.length > this.limit && <button
					class={joinClasses(s.showMore, showAll && s.less)}
					onClick={this.toggleShowAll}
				>
					{showAll ? copy.$VIEW_FEWER : copy.$VIEW_MORE}
				</button>}
			</div>
		);
	}
}
